<app-accordeon
	class="references"
	[view]="'classic'"
>
	<div
		class="references__header-block"
		title
	>
		<app-svg-document-one-list
			class="references__image"
			width="30px"
			heigth="30px"
		></app-svg-document-one-list>
		<h2 class="references__title-text">
			{{ group.name }}
		</h2>
	</div>
	<div
		class="references__content-block"
		content
	>
		<app-wizard-three-steps-container
			[wizard]="wizard"
			[stepBackHandler]="stepBackHandler"
		></app-wizard-three-steps-container>
	</div>
</app-accordeon>
